export default __webpack_public_path__ + "static/26-cdca6836ee6ff5c733ad949256003708.jpg";